export interface OpportunityDocumentsReq {
  opportunityDocumentTypeCode?: string;
  opportunityId?: number;
  opportunityBusinesslineId?: number;
  offsetId?: number;
  page?: number;
  fetch?: number;
}
